/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll("table").forEach(this.#formatTable);
    this.querySelectorAll("br").forEach(this.#formatLineBreak);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement("div");
    wrapper.classList.add("rte-table-wrapper");
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }

  /**
   * Marks visual-only line breaks as decorative to avoid
   * screen readers announcing them as empty groups/items.
   * @param {HTMLBRElement} lineBreak
   */
  #formatLineBreak(lineBreak) {
    lineBreak.setAttribute("aria-hidden", "true");
  }
}

if (!customElements.get("rte-formatter")) {
  customElements.define("rte-formatter", RTEFormatter);
}
